import React from 'react';
import {Alert} from 'react-bootstrap';
import {Icon, IconProps} from '@/components/icons/Icon';
import Button from '@/components/ui/Button';
import {InlineAlertProps} from './types';

const variantConfig = {
    success: {
        icon: 'mdi-check-circle',
        className: 'alert-success'
    },
    error: {
        icon: 'mdi-alert-circle',
        className: 'alert-danger'
    },
    warning: {
        icon: 'mdi-alert',
        className: 'alert-warning'
    },
    info: {
        icon: 'mdi-information',
        className: 'alert-info'
    }
};

const InlineAlert: React.FC<InlineAlertProps> = ({
    variant,
    title,
    message,
    dismissible = false,
    onDismiss,
    className = '',
    icon,
    actions = [],
    show = true
}) => {
    if (!show) {return null;}

    const config = variantConfig[variant];
    const alertIcon = icon || config.icon;

    return (
        <Alert
            variant={variant === 'error' ? 'danger' : variant}
            dismissible={dismissible}
            onClose={onDismiss}
            className={`${config.className} ${className}`.trim()}
        >
            <div className="d-flex align-items-center">
                {alertIcon && (
                    <Icon
                        name={alertIcon as IconProps['name']}
                        className="mr-2 flex-shrink-0"
                        style={{fontSize: '1.1rem'}}
                    />
                )}
                <div className="flex-grow-1">
                    {title && <Alert.Heading className="h6 mb-1">{title}</Alert.Heading>}
                    <div className="mb-0">{message}</div>
                    {actions.length > 0 && (
                        <div className="mt-2">
                            {actions.map((action, index) => (
                                <Button
                                    key={index}
                                    variant={action.variant || 'primary'}
                                    size="sm"
                                    onClick={action.onClick}
                                    loading={action.loading}
                                    className="mr-2"
                                    data-cy="inline-alert-btn">
                                    {action.label}
                                </Button>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </Alert>
    );
};

export default InlineAlert;
